import { render } from "./AtlasModel.vue?vue&type=template&id=f15f1b3c"
import script from "./AtlasModel.vue?vue&type=script&lang=js"
export * from "./AtlasModel.vue?vue&type=script&lang=js"

import "./AtlasModel.vue?vue&type=style&index=0&id=f15f1b3c&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__